import React, { Component } from 'react'
import {
  Dialog, DialogTitle, DialogActions, Card,
  CardContent, FormControl, Input, InputLabel
} from '@material-ui/core'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles';
import { openSnackBar } from '../../../actions/snack-bar';
import Grid from '@material-ui/core/Grid';
import LoadingButton from '../../LoadingButton'
import { TextMaskCustom } from '../../MaskedInput'
import { addRealtor } from '../../../actions/users'
import constant from "../../../config/constant";

const { MESSAGE: { INVALID_EMAIL }, EMAIL_REGEX } = constant;

class AddRealtorModal extends Component {
  state = {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    isAddingRealtor: false,
    isEditMode: false,
    orgId: null
  }

  componentDidMount() {
    const { editRealtorData, authentication: { authenticatedUser } } = this.props;
    this.setState({ orgId: authenticatedUser.id });
    if (editRealtorData) {
      const { first_name, last_name, phone, email, id } = editRealtorData;
      this.setState({ first_name, last_name, phone, email, userId: id, isEditMode: true });
    }
  }

  closeModal = (isUpdated) => {
    this.props.dispatch({ type: 'ADD_REALTOR', payload: false, isUpdated });
  }

  validatAndSubmit = event => {
    event.preventDefault();
    const { first_name, last_name, phone, email, userId, isEditMode, orgId } = this.state;
    if (!first_name) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter first name'
        })
      )
      return
    } else if (!last_name) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter last name'
        })
      )
      return
    } else if (!phone) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter mobile number'
        })
      )
      return
    } else if (phone.length < 10) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter a valid phone number'
        })
      )
      return
    } else if (!email) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter email address'
        })
      )
      return
    }
    if (!EMAIL_REGEX.test(email)) {
      this.props.dispatch(
        openSnackBar({
          message: INVALID_EMAIL
        })
      )
      return;
    }
    this.setState({ isAddingRealtor: true });
    const data = {
      first_name,
      last_name,
      phone,
      email,
      role: "realtor",
      created_by: orgId
    }

    this.props
      .dispatch(addRealtor(data, userId, isEditMode))
      .then(() => {
        this.setState({ isAddingRealtor: false });
        this.closeModal(true);
      })
      .catch(err => {
        const error = err.response.body;
        this.setState({ isAddingRealtor: false });
        let message = 'There was an error in adding realtor'
        if (error.message === 'users create error') {
          if (error.error.code === 'ER_DUP_ENTRY') {
            if (error.error.sqlMessage.indexOf("for key 'phone'") > -1) {
              message = 'The phone number is already exists in our system'
            }
          }
        }
        this.props.dispatch(
          openSnackBar({
            message
          })
        )
      });
  }
  render() {
    const { classes } = this.props;
    const { first_name, last_name, phone, email, isAddingRealtor, isEditMode } = this.state;
    return (
      <Dialog onClose={() => this.closeModal()} open={this.props.open} className={classes.realtorPopup} >
        <DialogTitle className={classes.popupTitle} onClose={() => this.closeModal()}>
          {isEditMode ? 'Edit Realtor' : `Add Realtor`}
        </DialogTitle>
        <Card className={classes.dialogContainer}>
          <form
            onSubmit={this.validatAndSubmit}
          >
            <CardContent className={classes.dialogInputContainer}>
              <Grid container spacing={0} className={classes.gridRow} >

                <Grid item sm={6} xs={12} className={classes.fieldGridLeft}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="first_name">
                      First Name
            </InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      id="first_name"
                      name="first_name"
                      value={first_name}
                      onChange={event => this.setState({ first_name: event.target.value })}
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>

                <Grid item sm={6} md={6} xs={12} className={classes.fieldGridRight}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="last_name">Last Name</InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      id="last_name"
                      name="last_name"
                      value={last_name}
                      onChange={event => this.setState({ last_name: event.target.value })}
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>
                <Grid item sm={6} xs={12} className={classes.fieldGridLeft}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="phone">Mobile Phone</InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      name="phone"
                      id="phone"
                      value={phone}
                      disabled={isEditMode}
                      onChange={event => this.setState({ phone: event.target.value })}
                      inputComponent={TextMaskCustom}
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>

                <Grid item sm={6} xs={12} className={classes.fieldGridRight}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="email">Email</InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      id="email"
                      name="email"
                      value={email}
                      onChange={event => this.setState({ email: event.target.value })}
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>

              </Grid>

            </CardContent>
            <DialogActions className={classes.dialogButtonContainer}>
              <LoadingButton
                variant="contained"
                type="submit"
                working={isAddingRealtor}
              >
                {isEditMode ? 'Update' : `Create Realtor`}
              </LoadingButton>
            </DialogActions>
          </form>
        </Card>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(AddRealtorModal)
